import { create } from "zustand";

const useThemeState = create((set) => ({
  theme: document.documentElement.getAttribute("data-bs-theme"),
  setTheme: (newtheme) => set(() => ({ theme: newtheme })),
}));

export default useThemeState;
